import { Switch } from "@/components/Base/Switch";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/Base/Form";
import { useFormContext } from "react-hook-form";

interface SwitchFieldProps {
  name: string;
  label: string;
  description?: string;
  disabled?: boolean;
  className?: string;
}

export const SwitchField = ({
  name,
  label,
  description,
  disabled = false,
  className = "",
}: SwitchFieldProps) => {
  const form = useFormContext();

  if (!form) {
    throw new Error("SwitchField must be used within a FormProvider");
  }

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <div className="flex flex-row justify-between">
            <FormLabel>{label}</FormLabel>
            {description && (
              <span className="text-sm text-muted-foreground">
                {description}
              </span>
            )}
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
              disabled={disabled || form.formState.isSubmitting}
              className="text-primary"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
